import {
    getSymbolInfoStreamRequestInfo,
    getSymbolInfoStreamRequestInfosForSymbols,
    GetSymbolInfoRequestPayload,
} from 'widgets/symbolInfo/SymbolInfoRequest';
import {
    StreamRequestInfo,
    WidgetCustomStreamManager,
    WidgetCustomManagedStreamOptions,
    WidgetStreamByRequestUidConfig,
} from 'widgets/streaming/widgetStreamManager/WidgetCustomStreamManager';
import State from 'store/State';
import { WidgetRequestResponseByUidRpcManager } from 'widgets/streaming/widgetStreamManager/RequestResponse/WidgetRequestResponseByUidRpcManager';
import { WidgetId } from 'widgets/WidgetId';
import { DataServices } from 'store/Services';

export const symbolInfoStreamConfig: WidgetStreamByRequestUidConfig<GetSymbolInfoRequestPayload> =
    {
        channelDestination: 'symbolInfo',
        managerFactory(
            options: WidgetCustomManagedStreamOptions
        ): WidgetCustomStreamManager {
            return new WidgetRequestResponseByUidRpcManager(options);
        },
        getWidgetStreamRequestInfo(
            state: State,
            services: DataServices,
            id: WidgetId
        ): Promise<StreamRequestInfo<GetSymbolInfoRequestPayload> | undefined> {
            return getSymbolInfoStreamRequestInfo(state, services, id);
        },
        getStreamRequestInfosForSymbols(
            state: State,
            services: DataServices,
            symbols: string[],
            config: { symbol?: string }
        ): Promise<StreamRequestInfo<GetSymbolInfoRequestPayload>[]> {
            return getSymbolInfoStreamRequestInfosForSymbols(
                state,
                services,
                symbols,
                config
            );
        },
    };
